export var URL_BASE = "https://res.cloudinary.com";
export var URL_SEPARATORS = "image/upload/|compara/images/";
export var REGEX = new RegExp(URL_BASE + ".*" + URL_SEPARATORS);
//# sourceMappingURL=constants.js.map